module.exports = __webpack_public_path__ + "463dad21ea486839e1c7177aed339253.svg";